module.exports = __webpack_public_path__ + "img/food-28.f2cc0185.jpg";